// External modules
import React from 'react';
import { ThemeProvider } from '@emotion/react';
import { PAYPAL_THEME } from '@paypalcorp/pp-react-theme-weasley-v7';
import { Sheet } from '@paypalcorp/pp-react-modal-weasley-v7';
import type { AtomicEventsAttributes } from '@/lib/atomics';

type SheetInterstitialProps = {
  action?: React.ReactNode;
  children: JSX.Element;
  footerContents?: JSX.Element;
  hideTitle?: boolean;
  isOpen?: boolean;
  onCloseComplete: () => void;
  testId?: string;
  title: string;
  atomicEventsAttributes?: AtomicEventsAttributes;
};

export const SheetInterstitial = ({
  action,
  children,
  footerContents,
  hideTitle = true,
  isOpen = true,
  onCloseComplete,
  testId,
  title,
  atomicEventsAttributes,
}: SheetInterstitialProps): JSX.Element => {
  return (
    <ThemeProvider theme={PAYPAL_THEME}>
      <Sheet
        action={action}
        center
        closeButtonProps={{
          'data-atomic-wait-domain': atomicEventsAttributes?.domain,
          'data-atomic-wait-flow': atomicEventsAttributes?.flow,
          'data-atomic-wait-intent': atomicEventsAttributes?.intent,
          'data-atomic-wait-task': atomicEventsAttributes?.task,
          'data-atomic-wait-viewname': atomicEventsAttributes?.viewName,
          'data-testid': 'close-sheet',
        }}
        data-testid={testId}
        footerAlign="center"
        footerContents={footerContents}
        hideTitle={hideTitle}
        isOpen={isOpen}
        onCloseComplete={onCloseComplete}
        title={title}
      >
        {children}
      </Sheet>
    </ThemeProvider>
  );
};
